const Activities = {
  SLEEPING: "SLEEPING",
  AWAKE: "AWAKE",
  MOTION: "MOTION"
};

function getActivityValue(activity, { SLEEPING, AWAKE, MOTION } = {}) {
  switch (activity) {
    case Activities.SLEEPING:
      return SLEEPING;

    case Activities.AWAKE:
      return AWAKE;

    case Activities.MOTION:
      return MOTION;

    default:
      return;
  }
}

window.getActivityValue = getActivityValue;

export { Activities, getActivityValue };
